module.exports = __webpack_public_path__ + "static/img/Logo.d2c07349.png";